import { ApolloClient } from "@apollo/client";
import { ContaminationDeclarationForEvent } from "../../graphql/queries/contaminationDeclarationForEvent";

/**
 * Whether a declaration may be *started* for one ASSET_REMOVE event, asked
 * outside React — the wizard decides whether to offer the follow-up before any
 * component is mounted for that event.
 *
 * The full "for event" document on purpose: it answers availability and the
 * "has one been started" lookup in a single round trip, and warms the cache the
 * declaration editor reads next.
 *
 * Returns false when the query fails. A follow-up that offers to start a
 * declaration the server then refuses is worse than one that never appears.
 */
export const resolveDeclarationAvailability = async (
    client: ApolloClient<unknown>,
    installedBaseEventId: string,
): Promise<boolean> => {
    try {
        const { data } = await client.query({
            query: ContaminationDeclarationForEvent,
            variables: { installedBaseEventId },
            fetchPolicy: 'network-only',
        });
        return data?.contaminationDeclarationAvailability === true;
    } catch {
        return false;
    }
};
